import React from 'react';
import { Dialog, DialogTitle, DialogContent, Divider, Typography, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function FormPopover(props) {
  const { title, children, openPopup, setOpenPopup } = props;
  return (
    <Dialog open={openPopup}>
      <DialogTitle>
        <div style={{ display: 'flex' }}>
          <Typography variant="h6" component="div" style={{ flexGrow: 1 }}>
            {title}
          </Typography>
          <Button
            color='inherit'
            onClick={() => { setOpenPopup(false) }}>
            <CloseIcon />
          </Button>
        </div>
      </DialogTitle>
      <Divider />
      <DialogContent>
        {children}
      </DialogContent>
    </Dialog>
  )
}